module.exports = {
  PlanSpecificDashboardComponentEvents: {
    PlanSpecificDashboard: {
      code: 'PlanSpecificDashboard',
      events: {
        Loaded: {
          description: 'Triggers when the dashboard is loaded.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Dashboard_Loaded'
          },
          ga: {
            action: 'PlanSpecific_Dashboard_Loaded'
          }
        },
        SavingsCoverClicked: {
          description: 'Triggers when what your savings could cover is clicked.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_SavingsCover_Clicked'
          },
          ga: {
            action: 'PlanSpecific_SavingsCover_Clicked'
          }
        },
        SavingsCoverLoaded: {
          description: 'Triggers when what your savings could cover is loaded.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_SavingsCover_Loaded'
          },
          ga: {
            action: 'PlanSpecific_SavingsCover_Loaded'
          }
        },
        AddAChildCTAClicked: {
          description: 'Triggers on click of Add a child CTA.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_AddaChildCTA_Clicked'
          },
          ga: {
            action: 'PlanSpecific_AddaChildCTA_Clicked'
          }
        },
        AddMoneyCTAClicked: {
          description: 'Triggers on click of Add money CTA.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_AddMoneyCTA_Clicked'
          },
          ga: {
            action: 'PlanSpecific_AddMoneyCTA_Clicked'
          }
        },
        WithdrawMoneyCTAClicked: {
          description: 'Triggers on click of Withdraw money CTA.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_WithdrawMoneyCTA_Clicked'
          },
          ga: {
            action: 'PlanSpecific_WithdrawMoneyCTA_Clicked'
          }
        },
        SharePlanClicked: {
          description: 'Triggers on click of Share this plan CTA.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_SharePlan_Clicked'
          },
          ga: {
            action: 'PlanSpecific_SharePlan_Clicked'
          }
        },
        BonusesClicked: {
          description: 'Triggers on click of Bonuses info icon.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Bonuses_Clicked'
          },
          ga: {
            action: 'PlanSpecific_Bonuses_Clicked'
          }
        },
        BonusesLoaded: {
          description: 'Triggers when bonuses pop-up is loaded.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Bonuses_Loaded'
          },
          ga: {
            action: 'PlanSpecific_Bonuses_Loaded'
          }
        },
        FeesClicked: {
          description: 'Triggers on click of Fees info icon.',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Fees_Clicked'
          },
          ga: {
            action: 'PlanSpecific_Fees_Clicked'
          }
        },
        FeesLoaded: {
          description: 'Triggers when fees pop-up is loaded',
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Fees_Loaded'
          },
          ga: {
            action: 'PlanSpecific_Fees_Loaded'
          }
        },
        ActivityViewAllClicked: {
          description: `Triggers on click of 'View all' on Activity tab.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Activity_ViewAll_Clicked'
          },
          ga: {
            action: 'PlanSpecific_Activity_ViewAll_Clicked'
          }
        },
        PlanActivityLoaded: {
          description: `Triggers when plan activity page is loaded.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_PlanActivity_Loaded'
          },
          ga: {
            action: 'PlanSpecific_PlanActivity_Loaded'
          }
        },
        PendingWithdrawalClicked: {
          description: `Triggers on click of a pending withdrawal request.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_PendingWithdrawal_Clicked'
          },
          ga: {
            action: 'PlanSpecific_PendingWithdrawal_Clicked'
          }
        },
        PendingTransferClicked: {
          description: `Triggers on click of a pending transfer request.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_PendingTransfer_Clicked'
          },
          ga: {
            action: 'PlanSpecific_PendingTransfer_Clicked'
          }
        },
        SchedulesClicked: {
          description: `Triggers on click of Schedules tab.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Schedules_Clicked'
          },
          ga: {
            action: 'PlanSpecific_Schedules_Clicked'
          }
        },
        SchedulesViewAllClicked: {
          description: `Triggers on click of 'View all' on Schedules tab.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Schedules_ViewAll_Clicked'
          },
          ga: {
            action: 'PlanSpecific_Schedules_ViewAll_Clicked'
          }
        },
        SchedulesLoaded: {
          description: `Triggers when schedules page is loaded.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Schedules_Loaded'
          },
          ga: {
            action: 'PlanSpecific_Schedules_Loaded'
          }
        },
        PortfolioClicked: {
          description: `Triggers on click of Portfolio tab.`,
          eventHub: {
            code: 'PlanSpecificDashboard',
            action: 'PlanSpecific_Portfolio_Clicked'
          },
          ga: {
            action: 'PlanSpecific_Portfolio_Clicked'
          }
        }
      }
    }
  }
};
